import Emotions from "../../../images/emotions.webp";
import BurningBridges from "../../../images/burningbridges.webp";
import Boyfriend from "../../../images/boyfriend.webp";
import Lights from "../../../images/lights.webp";


export const music = [
  {
    id: "1",
    title: "Emotions",
    description: "Produced by me and featuring MRAV",
    image: Emotions,
    link: "https://itsthetechie.com/emotions",
  },
  {

    id: 2,
    title: "Burning Bridges",
    description: "Produced by me and featuring ZNO and Itihas",
    image: BurningBridges,
    link: "https://bb.itsthetechie.com",
  },
  {
    id: 3,
    title: "Boyfriend",
    description: "Produced by me and featuring Itihas",
    image: Boyfriend,
    link: "https://boyfriend.itsthetechie.com",
  },
  {
    id: 4,
    title: "Lights",
    description: "Produced by me and featuring MRAV",
    image: Lights,
    link: "https://lights.itsthetechie.com",
  },
  
];


